import React from 'react';
import {
  requestAccessSubmitConfig as config,
  getRequestAccessPageInitialValues as getInitialValues,
  getRequestAccessMutation as getMutation,
} from '../../services/GraphQLTypes';
import { CreateDialogPanel, IUpdateDialogProps, UpdateDialogPanel, ViewPanel } from '../../layout/panels/ViewPanel';
import { RequestAccessPageFormPage } from '../form/RequestAccessFormPage';


export function RequestAccessPageUpdateDialog(props: IUpdateDialogProps): React.ReactElement {
  return (
    <CreateDialogPanel
      config={config}
      parent={props.dataItem}
      parentAccessor="parent"   
      getInitialValues={getInitialValues}
      getMutation={getMutation}
      component={RequestAccessPageFormPage}
      defaultQueries={[]}
      onClickOk={props.onClickOk}
      onClickCancel={props.onClickCancel}
      visible={props.visible}
    />
  );
}
